document.addEventListener('input', function (event) {
	// Only run on our select menu
	if (!(event.target.name).includes('field_61f6f5b8d6fef') && !(event.target.name).includes('field_62057216e57be')) return;

	//update the parent acf-field wrapper indicating what direction we're displaying
	event.target.parentNode.parentNode.setAttribute('data-direction', event.target.value);

	//add a class indicating it's been toggled
	event.target.classList.add('imgtxt_toggled');

}, false);

document.addEventListener('input', function (event) {

	// Only run on our select menu
	if (!(event.target.name).includes('.acf-button')) return;

	//fetch all column inputs that haven't been seen to
	let column_inputs = document.querySelectorAll('input[name="acf-block_61f6fb587c953[field_61f6fb1d7f3f7]"]');
	apply_column_widths(column_inputs);

}, false);

document.addEventListener("DOMContentLoaded", function() {
	setInterval(function(){

		//fetch all imgtxt inputs that haven't been seen to
		let img_txt_inputs = document.querySelectorAll('select[name*="field_61f6f5b8d6fef"]:not(.imgtxt_toggled), select[name*="field_62057216e57be"]:not(.imgtxt_toggled)');

		//fetch all column inputs that haven't been seen to
		let column_inputs = document.querySelectorAll('input[name="acf-block_61f6fb587c953[field_61f6fb1d7f3f7]"]');
		apply_column_widths(column_inputs);
	
		//if we have some
		if(img_txt_inputs) {

			//loop over the inputs
			for(let i = 0; i < img_txt_inputs.length; i++) {
	
				//update the parent acf-field wrapper indicating what direction we're displaying
				img_txt_inputs[i].parentNode.parentNode.setAttribute('data-direction', img_txt_inputs[i].value);

				//add a class indicating it's been toggled
				img_txt_inputs[i].classList.add('imgtxt_toggled');
			}
		}
		
		
	}, 1500);

	function apply_column_widths(columns) {
		if(columns) {

			//loop over the inputs
			for(let i = 0; i < columns.length; i++) {

				//get the total number of columns currently in use
				let totals = ((columns[i].nextElementSibling.children[0].children).length) - 1;
	
				//update the parent acf-field wrapper indicating what direction we're displaying
				columns[i].setAttribute('data-columns', totals);

				//add a class indicating it's been toggled
				columns[i].classList.add('columns_toggled');
			}
		}
	}
});